import "./CheckOutHeader.css";
import { ReactComponent as MainLogo } from "../../assets/icons/cleanBeeLogo.svg";
import { Link } from "react-router-dom";
import { useContext, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { setPageCount } from "../../state_management/actions";
import { stateType } from "../../store";
import { getServiceLink } from "../../utilities/misc";
import {
  disableSection,
  proceed_val_type
} from "../../state_management/reducers/order";
import { only_gift } from "../../utilities/cartUtilities";
import { cartInitialState } from "../../state_management/reducers/cart";
import { LocaleContext } from "../../AppProvider";

const CheckOutHeader = ({
  setPageCount,
  pageCount,
  orderSuccess,
  orderDirect,
  deactivate,
  cart
}: {
  setPageCount: (data: number) => void;
  pageCount: proceed_val_type;
  orderSuccess: boolean;
  orderDirect: boolean;
  deactivate?: boolean;
  cart: cartInitialState;
}) => {
  const { t, locale } = useContext(LocaleContext);
  const deactivateBars = deactivate || orderSuccess || orderDirect;
  const progressRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    progressRef.current?.scrollIntoView();
  }, [pageCount]);

  const service_link = getServiceLink(locale);
  const onlyGift = only_gift(cart);

  const steps = [
    {
      title: t("2. Extras"),
      isActive: pageCount === 0,
      isCompleted: pageCount >= 0 || deactivateBars,
      isDisabled: false,
      onClick: () => {
        if (!deactivateBars && pageCount >= 0) {
          setPageCount(0);
        }
      }
    },
    {
      title: t("3. Time"),
      isActive: pageCount === 1,
      isCompleted: pageCount >= 1 || deactivateBars,
      isDisabled: disableSection(1, onlyGift),
      onClick: () => {
        if (!deactivateBars && !disableSection(1, onlyGift) && pageCount >= 1) {
          setPageCount(1);
        }
      }
    },
    {
      title: t("4. Details"),
      isActive: pageCount === 2 || pageCount === 3,
      isCompleted: pageCount >= 2 || deactivateBars,
      isDisabled: false,
      onClick: () => {
        if (!deactivateBars && pageCount >= 2) {
          setPageCount(pageCount > 2 ? 3 : 2);
        }
      }
    },
    {
      title: t("5. Payment"),
      isActive: pageCount === 4,
      isCompleted: pageCount >= 4 || deactivateBars,
      isDisabled: false,
      onClick: () => {
        if (!deactivateBars && pageCount >= 4) {
          setPageCount(4);
        }
      }
    }
  ];

  return (
    <div className="checkOutHeader_wrapper center fdCol">
      <div className="logo">
        <Link className="mainLogo_link" to={`/${service_link}`}>
          <MainLogo />
        </Link>
      </div>
      <p>
        <span className="fontBlue">
          <a
            className="fontBlue"
            href={`tel:${t("help_num").replace(/\)|\(|\s/g, "")}`}
          >
            {t("help_num")}
          </a>
        </span>
      </p>
      <div ref={progressRef} className="progress">
        {/* Step 1: Cart */}
        <div
          className={`item completed fdCol ${
            deactivateBars ? `deactivate` : ``
          }`}
        >
          {deactivateBars ? (
            <>
              <span className="flex1">{t("1. Cart")}</span>
              <div className="bar"></div>
            </>
          ) : (
            <Link className="flex1 barLink item" to={"/cart"}>
              <span className="flex1">{t("1. Cart")}</span>
              <div className="bar"></div>
            </Link>
          )}
        </div>

        {/* Steps 2-5: Checkout Steps */}
        {steps.map((step, n) => (
          <div
            key={n}
            onClick={step.onClick}
            className={`item ${
              step.isCompleted ? `completed` : ``
            } fdCol ${step.isActive ? `active` : ``} ${
              deactivateBars ? `deactivate` : ``
            } ${step.isDisabled ? `grayed` : ``}`}
          >
            <span className="flex1">{step.title}</span>
            <div className="bar"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state: stateType) => ({
  cart: state.cartReducer,
  pageCount: state.commonReducer.pageCount,
  orderSuccess: state.orderReducer.success,
  orderDirect: state.orderReducer.direct
});

const mapDispatchToProps = (dispatch: (data: any) => any) => ({
  setPageCount: (data: number) => {
    dispatch(setPageCount(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckOutHeader);
